import {
  ArrowRight,
  Heart,
  KeySquare,
  Logout,
  Message2,
  MessageText1,
  NotificationBing,
  ShopAdd,
  ShoppingBag,
  User,
} from "iconsax-reactjs";
import type { useTranslations } from "next-intl";
import type { LinkItemData } from "@/components/core/Links";

/** Translator bound to the `profile` message namespace. */
type ProfileT = ReturnType<typeof useTranslations<"profile">>;

export const getProfileLinksData = (
  t: ProfileT,
  role?: "USER" | "ADMIN" | "GUEST",
  showBackToProfile = false,
  onLogoutClick?: () => void,
) => {
  const backToProfileLink: LinkItemData = {
    href: "/profile",
    icon: <ArrowRight size={20} />,
    label: t("links.backToProfile"),
    desktopOnly: true,
  };

  const mainLinks: LinkItemData[] = [
    {
      href:
        role === "GUEST" ? "/profile/standard-dashboard" : "/profile/dashboard",
      icon: <User size={20} />,
      label: t("links.dashboard"),
    },
    {
      href: "/profile/vendor",
      icon: <ShopAdd size={20} />,
      label: t("links.vendor"),
    },
    {
      href: "/profile/orders",
      icon: <ShoppingBag size={20} />,
      label: t("links.orders"),
    },
    {
      disabled: true,
      href: "/profile/favorites",
      icon: <Heart size={20} />,
      label: t("links.favorites"),
    },
    {
      href: "/profile/comments",
      icon: <Message2 size={20} />,
      label: t("links.comments"),
    },
    {
      disabled: true,
      href: "/profile/notifications",
      icon: <NotificationBing size={20} />,
      label: t("links.messages"),
    },
    {
      href: "/profile/feedback",
      icon: <MessageText1 size={20} />,
      label: t("links.feedback"),
    },
    {
      href: "/profile/security",
      icon: <KeySquare size={20} />,
      label: t("links.security"),
    },
    {
      href: "/profile/logout",
      icon: <Logout size={20} />,
      label: t("links.logout"),
      onClick: onLogoutClick,
    },
  ];

  return showBackToProfile ? [backToProfileLink, ...mainLinks] : mainLinks;
};
